// extracted by css-extract-rspack-plugin
export default {"links":"links--fLHJtxB0ofoOw666","link":"link--EuxosYutIHcdCYCM"};